export const PRODUCTS = [
    {
        id:0,
        name:"Cage",
        image:"/assets/images/products/cage_PN_547754.jpeg",
        price: "$525.80",
        featured: false,
        partnumber:"PN #547754"
    },    
    {
        id:1,
        name:"Gasket set",
        image:"/assets/images/products/gasket set_PN_08724.jpg",
        price: "$127.00",
        featured: false,
        partnumber:"PN #87241"
    },
    {
        id:2,
        name:"Link",
        image:"/assets/images/products/Link PN_65762.jpeg",
        price: "$278",
        featured: false,
        partnumber:"PN #65762"
    },
    {
        id:3,
        name:"Packing",
        image:"/assets/images/products/Packing_PN_65712.jpeg",
        price: "$2,500.00",
        featured: false,
        partnumber:"PN #65712"
        
    },
    {
        id:4,
        name:"Repair kit",
        image:"/assets/images/products/Repair kit_PN_67442.jpg",
        price: "$125",
        featured: false,
        partnumber:"PN #67442"
    },
    {
        id:5,
        name:"Seat ring",
        image:"/assets/images/products/seat_ring_PN_32274.jpg",
        price: "$930.00",
        featured: false,
        partnumber:"PN #32274"
    
    },
    {
        id:6,
        name:"Trim set",
        image:"/assets/images/products/trim_set_PN_43754.jpg",
        price: "$198.85",
        featured: true,
        partnumber:"PN #43754"  
    },
    {
        id:7,
        name:"Butterfly valve",
        image:"/assets/images/products/butterfly valve.jpeg",
        price: "$325.00",
        featured: true,
        partnumber:"PN #56774"  
    },
    {
        id:8,
        name:"Lantern ring",
        image:"/assets/images/products/lantern ring.jpeg",
        price: "$325",
        featured: true,
        partnumber:"PN #42556"  
    },
    {
        id:9,
        name:"Actuator spring",
        image:"/assets/images/products/Actuator part spring.jpg",
        price: "$1,050.98",
        featured: true,
        partnumber:"PN #57661"  
    },
    {
        id:10,
        name:"Actuator stem",
        image:"/assets/images/products/Actuator Stem.png",
        price: "$152.00",
        featured: true,
        partnumber:"PN #57662"  
    },
    {
        id:11,
        name:"Valve actuator",
        image:"/assets/images/products/valve Actuator.png",
        price: "$265.25",
        featured: true,
        partnumber:"PN #57663"  
    },
    {
        id:12,
        name:"First stage regulator",
        image:"/assets/images/products/First stage regulator.jpeg",
        price: "$478.50",
        featured: true,
        partnumber:"PN #98875"  
    },
    {
        id:13,
        name:"Flanged Control",
        image:"/assets/images/products/fisher Flanged Control.jpeg",
        price: "$789.00",
        featured: true,
        partnumber:"PN #98874"  
    },
    {
        id:14,
        name:"R-high Pressure",
        image:"/assets/images/products/Regulator high Pressure.jpeg",
        price: "$1,245.00",
        featured: true,
        partnumber:"PN #57663"  
    },
    {
        id:15,
        name:"Instrument",
        image:"/assets/images/products/Instrument.jpg",
        price: "$678.25",
        featured: true,
        partnumber:"PN #10998"  
    },
    {
        id:16,
        name:"Level Transmitter",
        image:"/assets/images/products/Level Transmitter Instrument.jpeg",
        price: "$789.00",
        featured: true,
        partnumber:"PN #10999"  
    },
    {
        id:17,
        name:"Greyline Instrument",
        image:"/assets/images/products/Greyline-pdfm50 Instrument.jpeg",
        price: "$1,245.00",
        featured: true,
        partnumber:"PN #10997"  
    },

];
